import React from 'react'
import { Router } from 'react-router'
import { ConfigProvider } from 'antd'
import { Provider } from 'mobx-react'

import AuthProviderHOC from 'Shared/HOCs/AuthProviderHOC'
import SmallScreenStub from 'Shared/organisms/SmallScreenStub'
import { getIsMobileDevice } from 'Shared/utils/device'

import ApplicationInsights from '../ApplicationInsights'

import { RootAppProps } from './types'

const RootApp: React.FC<RootAppProps> = ({
	authConfig,
	rootStore,
	isSmallScreenStub,
	children
}) => {
	const isMobileDevice = getIsMobileDevice()

	if (isSmallScreenStub && isMobileDevice) {
		return <SmallScreenStub />
	}

	return (
		<AuthProviderHOC config={authConfig}>
			<Provider rootStore={rootStore}>
				<Router history={rootStore.history}>
					{authConfig ? (
						<ApplicationInsights history={rootStore.history}>
							<ConfigProvider theme={{ hashed: false }}>{children}</ConfigProvider>
						</ApplicationInsights>
					) : (
						<ConfigProvider theme={{ hashed: false }}>{children}</ConfigProvider>
					)}
				</Router>
			</Provider>
		</AuthProviderHOC>
	)
}

export default RootApp
